export { default } from './legal-post';
